import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import * as tooltipCopy from '../../reba_copy/tooltipCopy'
import AvatarUpload from './AvatarUpload'
import {
  Grid,
  TextField,
  Button,
  Typography,
  InputAdornment,
  Tooltip,
  MenuItem
} from '@material-ui/core'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import InfoIcon from '@material-ui/icons/Info'
import MuiPhoneNumber from 'material-ui-phone-number'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 200,
    fontSize: 12
  }
}))

const AdditionalInfoForm = ({
    handleSubmit,
    handleChange,
    fields,
    handlePhone,
    handleAvatar,
    avatar,
    setIsCropping,
    errors,
    handlePronouns
  }) => {
  const classes = useStyles()

  return(
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={(fields.pronouns === 'custom' || fields.custom_pronouns) ? 6 : 12}
          role='pronouns'
        >
          <TextField
            name='pronouns'
            label='Pronouns'
            select
            value={fields.custom_pronouns ? 'custom' : fields.pronouns}
            fullWidth
            variant='outlined'
            onChange={handlePronouns}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Tooltip
                    title={tooltipCopy.genderPronouns}
                    arrow
                    placement='top-start'
                    classes={{tooltip: classes.tooltip}}
                  >
                    <InfoIcon fontSize='small' style={{color: '#adadad'}}/>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          >
            <MenuItem value=''>-- Select an option --</MenuItem>
            <MenuItem value='She/Her'>She/Her</MenuItem>
            <MenuItem value='He/Him'>He/Him</MenuItem>
            <MenuItem value='They/Them'>They/Them</MenuItem>
            <MenuItem value='custom'>Custom</MenuItem>
          </TextField>
        </Grid>
        {(fields.pronouns === 'custom' || fields.custom_pronouns) &&
          <Grid item xs={12} sm={6}>
            <TextField
              name='custom_pronouns'
              label='Enter Custom Pronouns'
              value={fields.custom_pronouns}
              inputProps={{maxLength: 25}}
              fullWidth
              variant='outlined'
              onChange={handleChange}
            />
          </Grid>
        }
        <Grid item xs={12} md={6}>
          <TextField
            name='title'
            label='Job Title'
            required
            inputProps={{maxLength: 100}}
            fullWidth
            variant='outlined'
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AvatarUpload
            handleAvatar={handleAvatar}
            avatar={avatar}
            setIsCropping={setIsCropping}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MuiPhoneNumber
            defaultCountry={'us'}
            label='Phone'
            variant='outlined'
            name='phone'
            required
            countryCodeEditable={false}
            fullWidth
            onChange={handlePhone}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <Tooltip
                    title={tooltipCopy.phone}
                    arrow
                    classes={{tooltip: classes.tooltip}}
                    placement='top-start'
                  >
                    <InfoIcon fontSize='small' style={{color: '#adadad'}}/>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            name='postal_code'
            label='Postal Code'
            error={errors.postal ? true : false}
            helperText={errors.postal}
            required
            fullWidth
            variant='outlined'
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <Tooltip
                    title={tooltipCopy.postal}
                    arrow
                    classes={{tooltip: classes.tooltip}}
                    placement='top-start'
                  >
                    <InfoIcon fontSize='small' style={{color: '#adadad'}}/>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            name='linkedin_url'
            label='LinkedIn'
            fullWidth
            variant='outlined'
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Tooltip
                    title={tooltipCopy.linkedIn}
                    arrow
                    classes={{tooltip: classes.tooltip}}
                    placement='top-start'
                  >
                    <LinkedInIcon fonstSize='small' style={{color: '#2867B2'}}/>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            name='twitter_url'
            label='Twitter'
            fullWidth
            variant='outlined'
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Tooltip
                    title={tooltipCopy.twitter}
                    arrow
                    classes={{tooltip: classes.tooltip}}
                    placement='top-start'
                  >
                    <TwitterIcon fonstSize='small' style={{color: '#1DA1F2'}}/>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid container item xs={12} justifyContent='center'>
          <Button
            variant='contained'
            color='primary'
            type='submit'
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default AdditionalInfoForm
